import React from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
  return (
    <footer className="footer d-flex align-items-center justify-content-center py-3" id="footer">
      <Link to="/"><img src="./images/logo.png" alt="logo" width="64px" /></Link>
      <p className="ml-5">&copy; 2019 by Said Nasser</p>
    </footer>
  );
}

export default Footer;
